const LangSidebar = {
  "sidebar.navigation._account": ["ACCOUNT SUMMARY", "TÓM TẮT TÀI KHOẢN"],
  "sidebar.navigation._dashboard": ["Dashboard", "Dashboard"],
  "sidebar.navigation._rewards": ["My Rewards", "QUÀ THƯỞNG CỦA TÔI"],
  "sidebar.navigation._profile": ["MY PROFILE", "TÀI KHOẢN CỦA TÔI"],
  "sidebar.navigation._updateProfile": ["Update Profile", "TÀI KHOẢN CỦA TÔI"],
  "sidebar.navigation._inviteFriends": ["Invite Friends", "LIÊN HỆ"],
  "sidebar.navigation._cards": ["MY CARDS", "THẺ CỦA TÔI"],
  "sidebar.navigation._transactions": ["My Transactions", "LỊCH SỬ GIAO DỊCH"],
  "sidebar.navigation._rewardsCatalogue": [
    "Rewards Catalogue",
    "Rewards Catalogue"
  ],
  "sidebar.navigation._aboutUs": ["ABOUT US", "LIÊN HỆ"],
  "sidebar.navigation._activateCard": ["ACTIVATE CARD", "ACTIVATE CARD"],
  "sidebar.navigation._changePassword": ["Change Password", "Change Password"],
  "sidebar.navigation._logout": ["Logout", "ĐĂNG XUẤT"],
  "sidebar.navigation._unregister": ["UNREGISTER", "HỦY TÀI KHOẢN"],
  "sidebar.navigation._downloadMobile": [
    "Download Mobile App",
    "TẢI ỨNG DỤNG ĐIỆN THOẠI"
  ],
  "sidebar.navigation._havingDifficulties": [
    "HAVING DIFFICULTIES? ",
    "BẠN CẦN GIÚP ĐỠ?"
  ],
  "sidebar.navigation._contact": ["Contact Us", "LIÊN HỆ"],
  "sidebar.navigation._faq": ["FAQ", "FAQ"],
  "sidebar.navigation._contactCsv": [
    "OUR CUSTOMER SERIVCE NOW",
    "CHÚNG TÔI NGAY"
  ]
};

export default LangSidebar;



// WEBPACK FOOTER //
// ./src/resources/modules/LangSidebar.js